/** @format */

const removeLocalStorage = ref => localStorage.removeItem(ref);

export default removeLocalStorage;
